<div class="checkout-confirmation box-container" aria-labelledby="checkout-confirmation-title" role="alert">
    <mat-icon class="checkout-confirmation__icon" aria-hidden="true" svgIcon="ico_checkmark_filled"> </mat-icon>

    <div class="checkout-confirmation__title">
        <h2 id="checkout-confirmation-title" class="category-heading">You’re all set!</h2>
        <h2 class="h1">
            Order number: <span aria-live="polite">{{ state?.confirmationNumber }}</span>
        </h2>
    </div>

    <p class="body-0" role="status">Your order has been confirmed. We’ll send your receipt by email shortly.</p>

    <div class="checkout-confirmation__actions">
        <!-- RCP-442: order history disabled
        <button
            mat-stroked-button
            aria-label="Go to your account to review your order"
            type="button"
            (click)="goToOrders()"
        >
            Go to account
        </button>
        -->

        <button mat-raised-button aria-label="Return to Homepage" routerLink="/">Return to Homepage</button>
    </div>
</div>
